import { portalPaths, UrlParams } from '@provision/portal-routes';
import { Route } from 'react-router-dom';
import { ClientExpanded } from 'src/pages/Clients/ClientView';
import { ConversationExpanded } from 'src/pages/Conversations';
import { RootSelectedView } from 'src/pages/CustomViews/custom-views-selected-view';
import { Drafts } from 'src/pages/Drafts';
import { SiteExpanded } from 'src/pages/Sites/SiteView/site-expanded';
import { getRoutePath } from 'src/routes/utils';
import { optionalRouteParam } from 'src/utils/routing';

export const EntityRoutes = ({ relative }: { relative?: boolean }) => (
  <>
    <Route path={getRoutePath(portalPaths.drafts.root(), relative)} element={<Drafts />} />

    <Route
      path={getRoutePath(portalPaths.conversation.full(UrlParams.recordId), relative)}
      element={<ConversationExpanded />}
    />

    <Route
      path={getRoutePath(
        portalPaths.site.full(UrlParams.recordId, optionalRouteParam(UrlParams.entityTab)),
        relative,
      )}
      element={<SiteExpanded />}
    />

    <Route
      path={getRoutePath(
        portalPaths.client.full(UrlParams.recordId, optionalRouteParam(UrlParams.entityTab)),
        relative,
      )}
      element={<ClientExpanded />}
    />

    <Route
      path={getRoutePath(
        portalPaths.entity.all({
          entityName: UrlParams.entityName,
          id: optionalRouteParam(UrlParams.recordId),
          customViewId: UrlParams.customViewId,
        }),
        relative,
      )}
      element={<RootSelectedView />}
    />
  </>
);
